import HomeComponent from '../components/home'

const Home = () => <HomeComponent />

export default Home;